import { useIntl } from "react-intl";
import { MenuItem, Stack } from "@mui/material";
import { ContextMenu } from "@packsize/components";
import ControlPointDuplicateOutlinedIcon from "@mui/icons-material/ControlPointDuplicateOutlined";

import { TwoLineDropdownItem } from "@/components/dropdown/two-line-dropdown-item";
import { useReproduceSingle } from "@/views/production/orders/history/use-reproduce-single";

interface OrdersHistoryActionMenuProps {
	readonly batchId: string;
}

export const OrdersHistoryActionMenu = ({ batchId }: OrdersHistoryActionMenuProps) => {
	const intl = useIntl();
	const { reproduceSingleFromBatch, isReproduceSingleFromBatchPending } = useReproduceSingle();

	return (
		<ContextMenu
			popoverProps={{
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "center",
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "right",
				},
			}}
		>
			<MenuItem
				onClick={() => {
					if (isReproduceSingleFromBatchPending) {
						return;
					}

					reproduceSingleFromBatch({ batchId });
				}}
			>
				<Stack gap={2} direction="row" alignItems="center">
					<ControlPointDuplicateOutlinedIcon sx={{ fontSize: 24, color: "text.primary" }} />
					<TwoLineDropdownItem
						primaryText={intl.formatMessage({ id: "Reproduce", defaultMessage: "Reproduce" })}
						secondaryText={intl.formatMessage({ id: "Single quantity", defaultMessage: "Single quantity" })}
					/>
				</Stack>
			</MenuItem>
		</ContextMenu>
	);
};
